'use client';

import type React from 'react';

import Button from '@/components/button/Button';
import { ButtonStyle } from '@/components/button/ButtonStyle.enum';

import { MovieDto } from '@cineamo/api/models/movie/v2/MovieDto.types';

import { IconRightArrow16 } from '@cineamo/ui/src/icons/ic-rightArrow';

import { useAnalytics } from '@cineamo/composables/src/providers/analyticsProvider';

type MoreAboutMovieCtaProps = {
    /** Fully-built embed URL (incl. UTM params), computed server-side. */
    href: string;
    /** CTA wording to render. */
    label: string;
    /** Movie id, for slicing the funnel per movie. */
    movieId: MovieDto['id'];
    primaryColor: string;
};

/**
 * Client wrapper around the "More about movie" CTA. Fires the "clicked" event on navigation,
 * which is the CTR numerator against the content-detail pageview.
 */
const MoreAboutMovieCta: React.FC<MoreAboutMovieCtaProps> = ({ href, label, movieId, primaryColor }) => {
    const { track } = useAnalytics();

    return (
        <a
            href={href}
            target="_self"
            onClick={() => track('More About Movie Clicked', { movieId: movieId ?? '' })}>
            <Button
                labelClassName="text-body-bold-12"
                style={ButtonStyle.text_only_no_padding}
                css={{ color: primaryColor }}
                trailingIcon={<IconRightArrow16 className="flex-none" />}>
                {label}
            </Button>
        </a>
    );
};

export default MoreAboutMovieCta;
